import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface VorlagePreviewDialogData {
    title: string;
    imageUrl: string;
}

@Component({
    selector: 'kiene-notschlacht-vorlage-preview-dialog',
    templateUrl: './vorlage-preview-dialog.component.html',
    styleUrls: ['./vorlage-preview-dialog.component.scss'],
})
export class NotschlachtVorlagePreviewDialogComponent {
    loadFailed = false;

    constructor(
        public dialogRef: MatDialogRef<NotschlachtVorlagePreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: VorlagePreviewDialogData,
    ) {}

    onImageError() {
        this.loadFailed = true;
    }

    close() {
        this.dialogRef.close();
    }
}
